import { HttpErrorResponse } from '@angular/common/http'

const SNACKBAR_DURATION = 5000
const SNACKBAR_ACTION = 'Ok'
const UNEXPECTED_ERROR = 'An unexpected error has occurred'

type SnackBarConfig = {
	panelClass: string
	message?: string
	duration: number
	action: string
}

export const errorSnackBarConfig = (err: HttpErrorResponse): SnackBarConfig => {
	const panelClass = err.status >= 400 && err.status < 500 ? 'snackbar-accent' : 'snackbar-warn'
	const message = err.error?.message ?? UNEXPECTED_ERROR

	return { panelClass, message, duration: SNACKBAR_DURATION, action: SNACKBAR_ACTION }
}

export const successSnackBarConfig = (): SnackBarConfig => ({
	panelClass: 'snackbar-success',
	duration: SNACKBAR_DURATION,
	action: SNACKBAR_ACTION,
})
